import React, { useState, useRef } from "react";
import { Stack, Switch, Typography, Divider } from "@mui/material";
import { styled } from '@mui/material/styles';
import "./styles.scss";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default function Notification() {

  return (
    <Stack className="email-info">

      <Stack sx={{ padding: "30px 0px" }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ paddingBottom: '10px', paddingLeft: '20px' }}>
          <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
          <Typography className="email-heading">Likes</Typography>
        </Stack>
        <Stack sx={{ paddingBottom: '20px', paddingLeft: '20px' }}>
          <Typography className="email-text" >SiliconNexus liked the photo</Typography>
        </Stack>
        <Divider />
      </Stack>

      <Stack >
        <Stack direction="row" spacing={2} alignItems="center" sx={{ paddingBottom: '10px', paddingLeft: '20px' }}>
          <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
          <Typography className="email-heading">Comments</Typography>
        </Stack>
        <Stack sx={{ paddingBottom: '20px', paddingLeft: '20px' }}>
          <Typography className="email-text">SiliconNexus commented: “Nice Shot!”</Typography>
        </Stack>
        <Divider />
      </Stack>

      <Stack sx={{ padding: "30px 0px" }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ paddingBottom: '10px', paddingLeft: '20px' }}>
          <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
          <Typography className="email-heading">Comments Likes</Typography>
        </Stack>
        <Stack sx={{ paddingBottom: '20px', paddingLeft: '20px' }}>
          <Typography className="email-text">SiliconNexus Like her comment: “Nice shot!”</Typography>
        </Stack>
        <Divider />
      </Stack>

      <Stack >
        <Stack direction="row" spacing={2} alignItems="center" sx={{ paddingBottom: '10px', paddingLeft: '20px' }}>
          <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
          <Typography className="email-heading">Reminders</Typography>
        </Stack>
        <Stack sx={{ paddingBottom: '20px', paddingLeft: '20px' }}>
          <Typography className="email-text">You have notifications you haven’t seen and other similar notifications.</Typography>
        </Stack>
        <Divider />
      </Stack>

    </Stack>
  )
}



